// import queryString from 'query-string';
import http from '.';
import { apiQrCode } from './apiRouter';

const getQrCodeDetail = (id) => {
  return http.get(`${apiQrCode}/${id}/qr-code`);
};

const updateQrCode = (id, body) => {
  return http.put(`${apiQrCode}/${id}/qr-code`, body);
};

const downloadQrCode = (id, body) => {
  return http.post(`${apiQrCode}/${id}/qr-code/download`, body);
};

const generateQrCodeImage = () => {
  return http.get(`${apiQrCode}/qrcode`);
};

export const QRServices = {
  getQrCodeDetail,
  updateQrCode,
  downloadQrCode,
  generateQrCodeImage,
};
